import { useCallback } from 'react';

/**
 * Hook para transformar input em uppercase
 * Use em campos de texto que devem ser sempre maiúsculos (exceto emails, senhas, etc)
 */
export const useUppercaseInput = () => {
  const handleUppercaseChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const input = e.target;
      const cursorPosition = input.selectionStart || 0;
      const originalValue = input.value;
      const upperValue = originalValue.toUpperCase();
      
      // Se o valor mudou (havia minúsculas), atualizar
      if (originalValue !== upperValue) {
        input.value = upperValue;
        
        // Restaurar posição do cursor após atualização
        requestAnimationFrame(() => {
          const newPosition = Math.min(cursorPosition, upperValue.length);
          input.setSelectionRange(newPosition, newPosition);
        });
      }
    },
    [],
  );

  return { handleUppercaseChange };
};

